// import React,{useState} from 'react'
// import expire from '../img/expire.png'
// // const Expired = () => {
// //   return (
// //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,paddingTop:"100px" }}>
// //   <img src={expire} alt="" style={{ height: '450px' }} className='col-lg-4 col-md-6 col-12' />
// // </div>
// //   )
// // }
// const Expired = () => {
//   const [timeLeft, setTimeLeft] = useState(0);
//   const [isRequesting, setIsRequesting] = useState(false);

//   const handleRenew = () => {
//     setIsRequesting(true);
//     setTimeLeft(600);
//   };

//   return (
//     <div style={{ textAlign: 'center', paddingTop: '80px' }}>
//       <img src={expire} alt="" style={{ height: '300px' }} />

//       <h3 style={{ color: 'red' }}>Subscription Expired</h3>

//       {!isRequesting && (
//         <button onClick={handleRenew}>Renew Now</button>
//       )}

//       {isRequesting && <p>Time Left: {timeLeft}s</p>}
//     </div>
//   );
// };
// export default Expired

import React, { useEffect, useState } from "react";
import expire from "../img/expire.png";
import { useSelector } from "react-redux";
import { sendAMCstatus } from "../../services/CoreApiServices";
import {getAMCstatus} from "../../services/CoreApiServices"

const Expired = () => {
  const { amcstatus } = useSelector((state) => state.amc);

  const [timeLeft, setTimeLeft] = useState(0);
  const [isRequesting, setIsRequesting] = useState(false);
  const { branch, branchlist } = useSelector((state) => state.branchlist);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
    const {BranchByUser} = useSelector((state) => state.userBranch);
  
    console.log("Branch  :", branch);
  // ⏱ Countdown Timer
  useEffect(() => {
    let timer;

    if (isRequesting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }

    if (timeLeft === 0 && isRequesting) {
      setIsRequesting(false);
    }

    return () => clearInterval(timer);
  }, [isRequesting, timeLeft]);

  // ⏰ Format Timer
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;

    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  // 📡 Renew Request
  // const handleRenew = async () => {
  //   try {
  //     setIsRequesting(true);
  //     setTimeLeft(600);

  //     const payload = {
  //       companyGuid: companyInfolist?.[0]?.guid || "",
  //       companyName: companyInfolist?.[0]?.name || "",
  //       companyFullName: companyInfolist?.[0]?.fullName || "",
  //       companyPhone: companyInfolist?.[0]?.phone || "",
  //       companyEmail: companyInfolist?.[0]?.email || "",
  //       companyAddress1: companyInfolist?.[0]?.address1 || "",
  //       companyAddress2: companyInfolist?.[0]?.address2 || "",
  //       companyCity: companyInfolist?.[0]?.address3 || "",
  //       companyState: companyInfolist?.[0]?.locationName || "",

  //       // companyName: amcstatus?.company?.name || "",
  //       // companyFullName: amcstatus?.company?.fullName || "",
  //       // companyPhone: amcstatus?.company?.phone || "",
  //       // companyEmail: amcstatus?.company?.email || "",
  //       // companyAddress1: amcstatus?.company?.address1 || "",
  //       // companyAddress2: amcstatus?.company?.address2 || "",
  //       // companyCity: amcstatus?.company?.address3 || "",
  //       // companyState: amcstatus?.company?.locationName || "",

  //       branchGuid: branch?.guid || "",
  //       branchName: branch?.name || "",
  //       branchAddress1: branch?.address1 || "",
  //       branchAddress2: branch?.address2 || "",
  //       branchCity: branch?.address3 || "",
  //       branchState: branch?.locationName || "",
  //       // branchName: amcstatus?.branch?.name || "",
  //       // branchAddress1: amcstatus?.branch?.address1 || "",
  //       // branchAddress2: amcstatus?.branch?.address2 || "",
  //       // branchCity: amcstatus?.branch?.address3 || "",

  //       serverName: window.navigator.platform || "",
  //       databaseName: "POS_DB",
  //       serverIP: "",
  //       windowsDbVersion: "1.0",
  //     };

  //     console.log("AMC Payload :", payload);

  //     await sendAMCstatus(payload);

  //   } catch (err) {
  //     console.error(err);
  //     setIsRequesting(false);
  //   }
  // };

  const handleRenew = async () => {
  try {
    setIsRequesting(true);
    setTimeLeft(600);

    const selectedBranch = branch || {};

    const payload = {
      companyGuid: companyInfolist?.[0]?.guid || "",
      companyName: companyInfolist?.[0]?.name || "",
      companyFullName: companyInfolist?.[0]?.fullName || "",
      companyPhone: companyInfolist?.[0]?.phone || "",
      companyEmail: companyInfolist?.[0]?.email || "",
      companyAddress1: companyInfolist?.[0]?.address1 || "",
      companyAddress2: companyInfolist?.[0]?.address2 || "",
      companyCity: companyInfolist?.[0]?.address3 || "",
      //companyState: companyInfolist?.[0]?.locationName || "",

      // ✅ Branch Details
      branchGuid: selectedBranch?.guid || null,
      branchName: selectedBranch?.name || "",
      branchAddress1: selectedBranch?.address1 || "",
      branchAddress2: selectedBranch?.address2 || "",
      branchCity: selectedBranch?.address3 || "",
     // branchState: selectedBranch?.locationName || "",

      serverName: "",
      databaseName: window.APP_CONFIG?.BASE_URL || "",
      serverIP: "",
      windowsDbVersion: "",
    };

    console.log("Selected Branch :", selectedBranch);
    console.log("AMC Payload :", payload);

    await sendAMCstatus(payload);
  } catch (err) {
    console.error(err);
    setIsRequesting(false);
  }
};

  return (
 <div
  style={{
    textAlign: "center",
    paddingTop: "80px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  }}
>
      <img
        src={expire}
        alt=""
        style={{ height: "400px" }}
      />

      {/* 🔘 Button */}
      {!isRequesting && (
        <button
          onClick={handleRenew}
          style={{
            background: "#ff9f43",
            border: "none",
            padding: "10px 20px",
            color: "#fff",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Renew Now
        </button>
      )}

      {/* ⏳ Timer */}
      {isRequesting && (
        <div
          style={{
            marginTop: "15px",
            color: "#ff4d4f",
            fontWeight: "bold",
          }}
        >
          Renewal request sent! Time left: {formatTime(timeLeft)}
        </div>
      )}
    </div>
  );
};

export default Expired;